import Routes from './component';
export default Routes;